import { makeApiRequest } from '../../utils/api-utils';

export const getAllUserReports = async () => makeApiRequest('/user-report/get-all');
export const getUserReportById = async (id: string) => makeApiRequest(`/user-report/get-by-id/${id}`);
export const getUserReportsForUser = async (userId: string) => makeApiRequest(`/user-report/reported/${userId}`); 